import { Button } from "src/@/components/ui/button";
import { Sheet, SheetTrigger, SheetContent, SheetHeader, SheetTitle } from "src/@/components/ui/sheet";
import Iconify from "src/components/Iconify";
import QrCode from "react-qr-code";
import { useSelector } from "react-redux";
import { mascararTel } from "src/utils/functions";

export function HelpComponent() {
    const { globalConfig } = useSelector(state => state.global);

    return (
        <Sheet>
            <SheetTrigger asChild>
                <button
                    className="h-9 w-9 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 hover:text-[#7C3AED] transition-colors relative"
                >
                    <Iconify icon="material-symbols:help-outline" width={20} height={20} />
                </button>
            </SheetTrigger>
            <SheetContent>
                <SheetHeader>
                    <SheetTitle className="text-xl font-bold text-gray-900">Central de ajuda</SheetTitle>
                </SheetHeader>

                {/* WhatsApp Support Section */}
                <div className="my-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                    <Button onClick={() => window.open(`https://api.whatsapp.com/send/?phone=${globalConfig?.provider?.config?.phone_support}&text=Ol%C3%A1,+sou+cliente+e+preciso+de+suporte&type=phone_number&app_absent=0`, '_blank')} className="my-4 w-full bg-green-500 hover:bg-green-600 text-white rounded-xl">
                        <Iconify icon="ic:baseline-whatsapp" className="h-5 w-5 mr-2" />
                        Conversar com suporte
                    </Button>
                    <p className="mt-4 text-sm text-gray-900">Contato: <span className="font-bold">{mascararTel(globalConfig?.provider?.config?.phone_support)}</span></p>
                    <p className="text-xs mt-5 text-gray-500">ou se preferir, converse com o suporte via WhatsApp do seu aparelho lendo o QRCode abaixo:</p>
                    <div className="bg-white p-2 rounded-lg w-fit mx-auto my-4">
                        <QrCode value={`https://wa.me/${globalConfig?.provider?.config?.phone_support}?text=Ol%C3%A1,+sou+cliente+e+preciso+de+suporte`} size={64} />
                    </div>
                </div>

                {/* Quick Access Buttons */}
                <div className="grid grid-cols-1 gap-4">
                    {globalConfig?.provider?.config?.links?.showAppAndroid && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.playstore_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="logos:android" className="h-8 w-8" /> */}
                            App Android
                        </Button>
                    )}

                    {globalConfig?.provider?.config?.links?.showAppWindows && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.app_windows_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="ic:outline-windows" className="h-8 w-8" /> */}
                            App Windows
                        </Button>
                    )}

                    {globalConfig?.provider?.config?.links?.showDocsApi && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.api_docs_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="mdi:file-document-outline" className="h-8 w-8" /> */}
                            Documentação api
                        </Button>
                    )}

                    {globalConfig?.provider?.config?.links?.showDocsApi && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.course_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="mdi:book-open-outline" className="h-8 w-8" /> */}
                            Curso - Aprenda funções da plataforma
                        </Button>
                    )}

                    {globalConfig?.provider?.config?.links?.feedback && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.feedback_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="mdi:book-open-outline" className="h-8 w-8" /> */}
                            SAC - Relatar problema
                        </Button>
                    )}

                    {globalConfig?.provider?.config?.links?.news && (
                        <Button onClick={() => window.open(globalConfig?.provider?.config?.links?.news_url, '_blank')} variant="outline" className="flex flex-col items-center py-4 h-auto rounded-xl border-gray-200">
                            {/* <Iconify icon="mdi:book-open-outline" className="h-8 w-8" /> */}
                            Novidades e atualizações
                        </Button>
                    )}

                </div>
            </SheetContent>
        </Sheet>
    );
}
